import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions, httpsCallable } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyDx7bOD1FaNPIVB9umaMGMW1EOUsIjOc2U",
  authDomain: "sirr-app-e2165.firebaseapp.com",
  projectId: "sirr-app-e2165",
  storageBucket: "sirr-app-e2165.firebasestorage.app",
  messagingSenderId: "532227033059",
  appId: "1:532227033059:web:f835db24085ca6a5d942d6",
  measurementId: "G-K5HBRKFPDR"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
const functions = getFunctions(app);

export const setUsernameCallable = httpsCallable(functions, 'setUsername');
export const resolveRecipientsCallable = httpsCallable(functions, 'resolveRecipients');
export const searchUsersCallable = httpsCallable(functions, 'searchUsers');
export const sendFriendRequestCallable = httpsCallable(functions, 'sendFriendRequest');
export const acceptFriendRequestCallable = httpsCallable(functions, 'acceptFriendRequest');
export const declineFriendRequestCallable = httpsCallable(functions, 'declineFriendRequest');
export const removeFriendCallable = httpsCallable(functions, 'removeFriend');
